import React, { useState } from "react";
import { Table } from "react-bootstrap";
import DownloadIcon from "@mui/icons-material/Download";
import PaymentMISHook from "./PaymentMISHook";
import VisibilityIcon from "@mui/icons-material/Visibility";
import * as XLSX from "xlsx";

const BatchMIS = () => {
  const [selectedVendor, setSelectedVendor] = useState("");
  const { utrData, VENDOR_LIST } = PaymentMISHook();
  const [expandedBatch, setExpandedBatch] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const COLUMNS = [
    "Batch No",
    "Vendor Name",
    "Invoice No",
    // "UTR No",
    // "Paid AA",
    "Payment Date",
    "Paid Cases",
    "Paid Total Repair Charges",
    "Paid Total Service Charges",
    "Total Paid Amount"
  ];

  const COLUMN_KEY_MAP = {
    "Batch No": "batchNo",
    "aa No": "aaNo",
    "imei No": "imeiNo",
    "Vendor Name": "vendorName",
    "UTR No": "utr",
    "Payment Date": "paymentDate",
    "Paid Cases": "paidCases",
    "Paid AA": "paidAA",
    "Invoice No": "invoiceNo",
    "Paid Service Charges": "paidServiceCharges",
    "Paid Repair Charges": "paidRepairCharges",
    "Paid GST": "paidGST",
    "Paid TDS": "paidTDS",
    "Paid Total Repair Charges": "paidTotalRepairCharges",
    "Paid Total Service Charges": "paidTotalServiceCharges",
    "Total Paid Amount": "totalPaidAmount",
  };

  const formatDate = (value) => {
    if (!value) return "N/A";
    const match = value.match(/^(\d{2})-(\d{2})-(\d{4})/);
    if (match) return `${match[1]}/${match[2]}/${match[3]}`;

    const d = new Date(value);
    if (isNaN(d)) return value;
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });
  };

  const formatNumber = (val) => {
    const num = Number(val);
    return isNaN(num) ? val : num.toFixed(2);
  };

  const filteredData = utrData.filter((item) => {
     if (selectedVendor && item.vendorName?.toLowerCase() !== selectedVendor.toLowerCase()) {
        return false;
      }
    if (fromDate || toDate) {
      const itemDate = new Date(item.createdDate);
      if (fromDate && itemDate < new Date(fromDate)) return false;
      if (toDate && itemDate > new Date(toDate)) return false;
    }
    return true;
  });

  return (
    <div className="container">
      <div
        className="pt-3 d-flex flex-wrap gap-3 align-items-end"
        style={{ gap: "20px" }}
      >
        <div style={{ minWidth: "250px" }}>
          <label className="mb-1 text-sm font-medium">Vendor Name</label>
          <select
            className="form-select"
            value={selectedVendor}
            onChange={(e) => setSelectedVendor(e.target.value)}
          >
            <option value="">All Vendors</option>
            {VENDOR_LIST.map((v) => (
              <option key={v} value={v}>
                {v}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="mb-1 text-sm font-medium">From Date</label>
          <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div>
          <label className="mb-1 text-sm font-medium">To Date</label>
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <div>
          {/* <button
            className="btn btn-primary"
            style={{ backgroundColor: "#7E00D1", border: "0px", width: "200px" }}
            onClick={() => {
              if (filteredData.length === 0) return;

              const headers = COLUMNS;
              const rows = filteredData
                .map(
                  (row) =>
                    "<tr>" +
                    headers
                      .map((h) => {
                        const val = row[COLUMN_KEY_MAP[h]];
                        if (h === "Payment Date") return `<td>${formatDate(val)}</td>`;
                        if (typeof val === "number" || !isNaN(parseFloat(val)))
                          return `<td>${formatNumber(val)}</td>`;
                        return `<td>${val ?? ""}</td>`;
                      })
                      .join("") +
                    "</tr>"
                )
                .join("");

              const excelFile = `
                <html xmlns:o="urn:schemas-microsoft-com:office:office"
                      xmlns:x="urn:schemas-microsoft-com:office:excel"
                      xmlns="http://www.w3.org/TR/REC-html40">
                <head>
                  <!--[if gte mso 9]><xml>
                  <x:ExcelWorkbook>
                    <x:ExcelWorksheets>
                      <x:ExcelWorksheet>
                        <x:Name>Pending Payment MIS</x:Name>
                        <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                      </x:ExcelWorksheet>
                    </x:ExcelWorksheets>
                  </x:ExcelWorkbook>
                  </xml><![endif]-->
                </head>
                <body>
                  <table>
                    <tr>${headers.map((h) => `<th style="font-size:12px;">${h}</th>`).join("")}</tr>
                    ${rows}
                  </table>
                </body>
                </html>
              `;

              const blob = new Blob([excelFile], { type: "application/vnd.ms-excel" });
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = "UTRPaymentMIS.xlsx";
              a.click();
              URL.revokeObjectURL(url);
            }}
          >
            <DownloadIcon /> Download MIS
          </button> */}
             <button
                      className="btn btn-primary"
                      style={{ backgroundColor: "#7E00D1", border: 0, width: 200 }}
                      onClick={() => {
                        if (filteredData.length === 0) return;
          
                        const exportRows = filteredData.map((row) => {
                          const obj = {};
                          COLUMNS.forEach((col) => {
                            obj[col] = row[COLUMN_KEY_MAP[col]] ?? "";
                          });
                          return obj;
                        });
          
                        const wb = XLSX.utils.book_new();
                        const ws = XLSX.utils.json_to_sheet(exportRows);
                        XLSX.utils.book_append_sheet(wb, ws, "Pending Payment MIS");
          
                        XLSX.writeFile(wb, "UTRPaymentMIS.xlsx");
                      }}
                    >
                      <DownloadIcon /> Download MIS
                    </button>
        </div>
      </div>

      <div className="container mt-4" style={{ overflow: "auto" }}>
        {filteredData.length > 0 ? (
          <Table className="bg-white text-center border-0 network_table mt-3">
            <thead
              style={{ backgroundColor: "#EEF4FF", position: "sticky", top: 0, zIndex: 1 }}
            >
              <tr className="text-dark fw-semibold table_th_border">
                <th>View</th>
                {COLUMNS.map((col) => (
                  <th key={col}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.map((row, idx) => {
                const isExpanded = expandedBatch === row.batchNo;

                return (
                  <React.Fragment key={idx}>
                    <tr className="text-center border-bottom network_td_item">
                      <td className="align-middle">
                        <button
                          className="btn btn-link p-0"
                          onClick={() =>
                            setExpandedBatch(isExpanded ? null : row.batchNo)
                          }
                          title="View Details"
                        >
                          <VisibilityIcon style={{ color: "#7E00D1" }} />
                        </button>
                      </td>
                      {COLUMNS.map((col) => (
                        <td key={col}>
                          {row[COLUMN_KEY_MAP[col]] && String(row[COLUMN_KEY_MAP[col]]).trim() !== ""
                            ? col === "Payment Date"
                              ? formatDate(row[COLUMN_KEY_MAP[col]])
                              : (typeof row[COLUMN_KEY_MAP[col]] === "number" ||
                                !isNaN(parseFloat(row[COLUMN_KEY_MAP[col]]))) &&
                                !["Batch No", "Paid AA", "UTR No","Paid Cases"].includes(col)     // <-- skip
                                ? formatNumber(row[COLUMN_KEY_MAP[col]])
                                : row[COLUMN_KEY_MAP[col]]
                            : "N/A"}
                        </td>
                      ))}
                    </tr>

                    {isExpanded && (
                      <tr>
                        <td colSpan={COLUMNS.length + 1}>
                          <div className="p-2">
                            <Table bordered size="sm">
                              <thead style={{ background: "#f7f7f7" }}>
                                <tr>
                                  <th>SR No.</th>
                                  <th>Paid AA</th>
                                  <th>UTR No</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(() => {
                                  const aaArr = row.paidAA?.split(/\s*,\s*/) || [];
                                  const utrArr = row.utr?.split(/\s*,\s*/) || [];
                                  const maxLen = Math.max(aaArr.length, utrArr.length);

                                  return Array.from({ length: maxLen }).map((_, i) => (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td>{aaArr[i] || "-"}</td>
                                      <td>{utrArr[i] || "-"}</td>
                                    </tr>
                                  ));
                                })()}
                              </tbody>
                            </Table>
                          </div>
                        </td>
                      </tr>
                    )}

                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <p className="mt-4 text-center text-muted">No data found</p>
        )}
      </div>
    </div>
  );
};

export default BatchMIS;
